// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _BilibiliOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/BilibiliOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var BilibiliOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _BilibiliOutlined.default
    }));
};
/**![bilibili](data:image/svg+xml;base64,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) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(BilibiliOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'BilibiliOutlined';
}
var _default = RefIcon;
